<template>
  <div>
    <HeadlineContainer headline="Edit Competition Team" :breadcrumbs="breadcrumbs">
      <button type="button" class="btn btn-white pull-right" @click="destroy">
        <i class="fa fa-trash"></i> Delete
      </button>
    </HeadlineContainer>

    <LoadingContainer v-if="loading"/>

    <div v-else class="container">
      <div class="row">
        <div class="col-xs-6">
          <help-text>
            <h3>
              Teams
            </h3>

            <p>
              This list displays the participants in the team.
            </p>

            <button
                type="button"
                class="btn btn-black btn-sm"
                data-toggle="modal"
                data-target="#create-competition-participant-modal"
            >
              <i class="fa fa-plus"></i> Create Participant
            </button>
          </help-text>
        </div>

        <div class="col-xs-18">
          <CompetitionParticipantList :competition-team="competitionTeam"/>
        </div>
      </div>

      <hr class="panel-separator">

      <form @submit.prevent="submit">
        <div class="row">
          <div class="col-xs-6">
            <HelpText>
              <h3>
                Edit Competition Team
              </h3>

              <p>
                Enter the details of the competition team.
              </p>
            </HelpText>
          </div>

          <div class="col-xs-18">
            <div class="panel panel-default">
              <div class="panel-body">
                <TextFormGroup
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the competition team."
                    :error="getError('name')"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-offset-6 col-xs-18">
            <button type="submit" class="btn btn-block btn-black tw-mb-8">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import CompetitionParticipantList from '../../../components/Administration/CompetitionParticipants/Panels/List'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {
    CompetitionParticipantList,
    HeadlineContainer,
    HelpText,
    LoadingContainer,
    SubmitFormGroup,
    TextFormGroup
  },

  mixins: [Errors],

  props: {
    competitionId:{
      required: true,
    },

    competitionTeamId:{
      required: true,
    },
  },

  data() {
    return {
      competitionTeam: null,
      data: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    breadcrumbs() {
      return [
        {url: '/competitions', text: 'Competitions'},
        {text: 'Edit'}
      ]
    }
  },

  methods: {
    load() {
      http.get('/api/v2/competition-teams/' + this.competitionTeamId).then(response => {
        this.competitionTeam = response.data.data

        this.data = response.data.data.attributes

        this.loading = false
      })
    },

    submit() {
      http.put('/api/v2/competition-teams/' + this.competitionTeamId, this.data)
          .then(response => {
            this.competitionTeam = response.data.data

            notify.success('The competition team was saved')
          })
          .catch(this.catchValidationErrors)
    },

    destroy() {
      modal.confirm('Are you sure that you want to delete the competition team?', () => {
        http.delete('/api/v2/competition-teams/' + this.competitionTeamId)
            .then(() => {
              notify.success('The competition team was deleted')

              this.$router.push('/competitions/'+this.competitionId+'/edit')
            })
      })
    }
  }
}
</script>
